import { S as Skeleton, d as defineCustomElement$1 } from './skeleton.js';

const TtSkeleton = Skeleton;
const defineCustomElement = defineCustomElement$1;

export { TtSkeleton, defineCustomElement };
